var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quill mt-3"},[_c('div',{attrs:{"id":_vm.toolbarId}},[_c('div',{staticClass:"ql-formats"})]),_c('div',{ref:"editor",attrs:{"id":_vm.editorId,"name":_vm.name}})])}
var staticRenderFns = []

export { render, staticRenderFns }